import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import ChromePicker from "react-color/lib/components/chrome/Chrome";
import { ColorResult } from "react-color";

import { setGeneralDesignColor } from "@store";

import { InputGroupWrapper } from "./InputGroupWrapper";

const ESCAPE_KEY = "Escape";

export function ColorPickerWrapper({
    item,
    setColor,
}: {
    item: ColorsContentType;
    setColor: React.Dispatch<React.SetStateAction<ColorsContentType[]>>;
}): JSX.Element {
    const color = item.content;
    const [isColorPickerShown, setIsColorPickerShown] = React.useState<boolean>(
        false
    );

    // Allow keyboard users to dismiss the open picker with Escape (the
    // click-outside overlay is mouse-only). Listener is attached only while
    // the picker is open.
    React.useEffect(() => {
        if (!isColorPickerShown) {
            return;
        }
        function handleEscapeKeyDown(event: KeyboardEvent) {
            if (event.key === ESCAPE_KEY) {
                setIsColorPickerShown(false);
            }
        }
        document.addEventListener("keydown", handleEscapeKeyDown);
        return () => {
            document.removeEventListener("keydown", handleEscapeKeyDown);
        };
    }, [isColorPickerShown]);

    function handleColorPickerOnChangeEvent(color: ColorResult, index: number) {
        setColor((prevState: ColorsContentType[]) => {
            let newState = [...prevState];
            newState = newState.map((item: ColorsContentType) => {
                if (item.id === index) {
                    return {
                        ...item,
                        content: color.hex as ColorType,
                    };
                }
                return { ...item };
            });
            setGeneralDesignColor(newState);
            return newState;
        });
    }

    function handleShowColorPickerOnClickEvent() {
        setIsColorPickerShown(!isColorPickerShown);
    }

    function handleColorPickerCloseEvent() {
        setIsColorPickerShown(false);
    }

    return (
        <AvForm
            className="btn-group"
            style={{
                display: "grid",
                gridColumnGap: "2px",
            }}
        >
            <InputGroupWrapper
                title={item.title}
                color={color}
                testId={`design-color-picker-swatch-${item.id}`}
                handleShowColorPickerOnClickEvent={
                    handleShowColorPickerOnClickEvent
                }
            />

            {isColorPickerShown ? (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 2,
                        marginLeft: "-71px",
                        marginRight: "91px",
                        marginTop: "60px",
                    }}
                >
                    <div
                        data-testid="design-color-picker-overlay"
                        role="presentation"
                        style={{
                            position: "fixed",
                            top: "0px",
                            right: "0px",
                            bottom: "0px",
                            left: "0px",
                        }}
                        onClick={handleColorPickerCloseEvent}
                    />
                    <ChromePicker
                        onChangeComplete={(colorResult) =>
                            handleColorPickerOnChangeEvent(colorResult, item.id)
                        }
                        color={color}
                    />
                </div>
            ) : null}
        </AvForm>
    );
}
